var ubian = ubian || {};

ubian.timeTicket = {};

/**
 * currently selected options for new time ticket
 * @type Object
 */
ubian.timeTicket.selectedOptions = {
  companyID: null,
  zones: null,
  tariffZone: null,
  snr: null,
  ctl: null,
  from: null,
  cardOK: null,
  priceOK: null,
  validity: null,
  cardValidity: null,
  discountValidity: null,
};
/**
 * update price displayed in time ticket validity selection idalog
 * @param {Object} dialog
 * @param callback onUpdate
 * @returns {void}
 */
ubian.timeTicket.updatePrice = function (dialog, onUpdate) {
  $(dialog).find(".loader-icon").show();
  $.post(
    ubian.routes["time_ticket_get_price"],
    ubian.timeTicket.selectedOptions,
    function (res) {
      $(dialog).find(".loader-icon").hide();
      if (res.status === "ok") {
        ubian.timeTicket.selectedOptions.priceOK = true;
        // display real price
        $(dialog).find(".js-price-real").removeClass("hidden");
        $(dialog)
          .find(".js-price-real-int")
          .text(ubian.utils.price(res.price.price.valueFloat, "int"));
        $(dialog)
          .find(".js-price-real-frac")
          .text(ubian.utils.price(res.price.price.valueFloat, "frac"));
        $(dialog)
          .find(".js-price-real-currency")
          .text(res.price.price.currencySymbol);
        if (res.price.price.fullPrice > 0) {
          $(dialog).find(".js-price-original").removeClass("hidden");
          $(dialog)
            .find(".js-price-original-int")
            .text(ubian.utils.price(res.price.price.fullPrice / 100, "int"));
          $(dialog)
            .find(".js-price-original-frac")
            .text(ubian.utils.price(res.price.price.fullPrice / 100, "frac"));
          $(dialog)
            .find(".js-price-original-currency")
            .text(res.price.price.currencySymbol);
          /**
           * @todo doplnit zobrazenie zlavy
           */
          $(dialog)
            .find(".js-price-original-discount")
            .text("Poskytnutá BMK zľava");
        } else {
          $(dialog).find(".js-price-original").addClass("hidden");
        }
      }
      if (res.message) {
        $(dialog).find(".error").removeClass("hidden");
        $(dialog).find(".error").html(ubian.translate(res.message));
      }
      onUpdate(res.validTo);
      ubian.timeTicket.enableSubmit(dialog);
    }
  ).fail(function () {
    ubian.timeTicket.selectedOptions.priceOK = false;
    $(dialog).modal("hide");
    ubian.utils.alert(ubian.translate("JS.Error.TimeTicket.BuyImpossible"));
  });
};
/**
 * update validity selection dialog - error messsges, price, date ranges
 * @param {moment} selectedDate
 * @param {Object} dialog
 * @returns {void}
 */
ubian.timeTicket.updateValiditySelectDialog = function (selectedDate, dialog) {
  var d = selectedDate;
  ubian.timeTicket.selectedOptions.from = Math.round(
    selectedDate.valueOf() / 1000
  );
  ubian.timeTicket.disableSubmit(dialog);
  $(dialog).find(".error").addClass("hidden");
  $(dialog).find("#selectedDate").addClass("hidden");
  ubian.timeTicket.updatePrice(dialog, function (toTimestamp) {
    if (!toTimestamp) {
      return;
    }
    to = moment(toTimestamp * 1000);
    var errorMsg = "";
    // discount validity - continue with full price if exceeded
    if (
      to.valueOf() / 1000 >
      ubian.timeTicket.selectedOptions.discountValidity
    ) {
      $(dialog).find(".error").removeClass("hidden");
      errorMsg = ubian
        .translate("JS.TimeTicket.ValidityDialog.DiscountExpires")
        .replace(
          "%date%",
          moment(
            ubian.timeTicket.selectedOptions.discountValidity * 1000
          ).format(ubian.config.dateFormat)
        );
      $(dialog).find(".error").text(errorMsg);
    }
    // card validity - fail if exceeded
    if (to.valueOf() / 1000 > ubian.timeTicket.selectedOptions.cardValidity) {
      $(dialog).find(".error").removeClass("hidden");
      errorMsg = ubian
        .translate("JS.TimeTicket.ValidityDialog.CardExpires")
        .replace(
          "%date%",
          moment(ubian.timeTicket.selectedOptions.cardValidity * 1000).format(
            ubian.config.dateFormat
          )
        );
      $(dialog).find(".error").text(errorMsg);
    } else {
      ubian.timeTicket.selectedOptions.cardOK = true;
    }
    // show validity range
    $(dialog).find("#selectedDate").removeClass("hidden");
    $(dialog).find("#start").text(d.format("L"));
    $(dialog).find("#end").text(to.format("L"));
  });
};
/**
 * disable submit button
 * @param {type} dialog
 * @returns {undefined}
 */
ubian.timeTicket.disableSubmit = function (dialog) {
  ubian.timeTicket.selectedOptions.priceOK = false;
  ubian.timeTicket.selectedOptions.cardOK = false;
  $(dialog).find(".js-submit-time-ticket-selection").addClass("btn-gray");
  $(dialog).find(".js-submit-time-ticket-selection").removeClass("btn-green");
};
/**
 * enable submit button
 * @param {type} dialog
 * @returns {undefined}
 */
ubian.timeTicket.enableSubmit = function (dialog) {
  if (
    ubian.timeTicket.selectedOptions.priceOK &&
    ubian.timeTicket.selectedOptions.cardOK
  ) {
    $(dialog).find(".js-submit-time-ticket-selection").removeClass("btn-gray");
    $(dialog).find(".js-submit-time-ticket-selection").addClass("btn-green");
  }
};

/**
 * display dialog to select validity of timeTicket
 * @param {int} company company id
 * @param {string} zones list of selected zones
 * @param {string} snr serial number of card
 * @param {int} ctl ctl of timeticket
 * @param {int} validity timeticket validity in days
 * @param {type} maxDate max allowed date to select
 * @param {type} cardValidity card validity date
 * @param {type} discountValidity discount validity date
 * @returns {void}
 */
ubian.timeTicket.showValiditySelectDialog = function (
  company,
  zones,
  tariffZone,
  snr,
  ctl,
  validity,
  maxDate,
  cardValidity,
  discountValidity,
  dateFrom
) {
  moment.locale("sk");
  if (!dateFrom) {
    // min date is tomorrow
    var startDate = moment().add(1, "days");
  } else {
    var startDate = moment(dateFrom);
    if (startDate < moment()) {
      startDate = moment().add(1, "days");
    }
  }
  var endDate = moment(maxDate);
  if (endDate < startDate) {
    ubian.utils.alert(ubian.translate("JS.Error.DateRangeExceeded"));
    return;
  }
  var dialog = $("#js-validity-dialog").html();
  ubian.timeTicket.selectedOptions.companyID = company;
  ubian.timeTicket.selectedOptions.zones = zones;
  ubian.timeTicket.selectedOptions.tariffZone = tariffZone;
  ubian.timeTicket.selectedOptions.snr = snr;
  ubian.timeTicket.selectedOptions.ctl = ctl;
  ubian.timeTicket.selectedOptions.validity = validity;
  ubian.timeTicket.selectedOptions.cardValidity = cardValidity;
  ubian.timeTicket.selectedOptions.discountValidity = discountValidity;
  dialog = dialog.replace("%card-snr%", "<span>" + snr + "</span>");
  dialog = $(dialog);
  $(dialog).modal();
  var picker, pickermobile;
  picker = $(dialog)
    .find("#datetimepicker12")
    .datetimepicker({
      inline: true,
      sideBySide: false,
      minDate: startDate,
      locale: "sk",
      maxDate: endDate,
      disabledDates: [endDate],
    });
  pickermobile = $(dialog)
    .find("#datetimepicker-mobile")
    .datetimepicker({
      inline: false,
      sideBySide: false,
      minDate: startDate,
      locale: "sk",
      maxDate: endDate,
      disabledDates: [endDate],
      ignoreReadonly: true,
      widgetPositioning: {
        horizontal: "auto",
        vertical: "bottom",
      },
      format: "DD.MM.YYYY",
    });
  ubian.timeTicket.updateValiditySelectDialog(moment(startDate), dialog);

  picker.on("dp.change", function (e) {
    ubian.timeTicket.updateValiditySelectDialog(e.date, dialog);
  });
  pickermobile.on("dp.change", function (e) {
    ubian.timeTicket.updateValiditySelectDialog(e.date, dialog);
    pickermobile.data("DateTimePicker").hide();
  });

  $(dialog)
    .find(".js-submit-time-ticket-selection")
    .click(function () {
      if (
        ubian.timeTicket.selectedOptions.cardOK &&
        ubian.timeTicket.selectedOptions.priceOK
      ) {
        ubian.timeTicket.submitValidity(
          ubian.timeTicket.selectedOptions,
          dialog
        );
      }
      return false;
    });
};
/**
 * submit selected validity
 * @param {ubian.timeTicket.selectedOptions} options
 * @param {dialog} dialog
 * @returns {undefined}
 */
ubian.timeTicket.submitValidity = function (options, dialog) {
  if (typeof dialog !== "undefined") {
    ubian.timeTicket.disableSubmit(dialog);
  }
  $(dialog).find(".loader-icon").show();
  $.post(ubian.routes["time_ticket_submit_validity"], options, function (res) {
    if (res.status === "ok") {
      ubian.cart.unhideSummaryBar();
      window.location = ubian.routes["basket_view"];
    } else {
      $(dialog).find(".loader-icon").hide();
      ubian.utils.alert(ubian.translate(res.message), null, null, function () {
        ubian.timeTicket.selectedOptions.priceOK = true;
        ubian.timeTicket.selectedOptions.cardOK = true;
        ubian.timeTicket.enableSubmit(dialog);
      });
    }
  });
};
/**
 * show reason why renewal is not possible
 * @param {type} buyAllowed
 * @param {type} requiredValidity
 * @param {type} cardValidity
 * @param {type} discountValidity
 * @param {type} PCLSale
 * @param {type} PCLAvailable
 * @returns {undefined}
 */
ubian.timeTicket.showExtendImpossibleDialog = function (
  buyAllowed,
  requiredValidity,
  cardValidity,
  discountValidity,
  PCLSale,
  PCLAvailable
) {
  var title = ubian.translate("JS.Error.TimeTicket.ExtendImpossible");
  var message = "";
  if (!buyAllowed) {
    message = ubian.translate("JS.Error.TimeTicket.CompanyNotSupported");
  }
  if (!PCLSale) {
    message = ubian.translate("JS.Error.TimeTicket.CompanyNotSupported");
  }
  if (!PCLAvailable) {
    message = ubian.translate("JS.Error.TimeTicket.InvalidPeriod");
  }
  if (cardValidity < requiredValidity) {
    message = ubian.translate("JS.Error.TimeTicket.CardExpires", {
      "%date%": moment(cardValidity * 1000).format(ubian.config.dateFormat),
    });
  }
  if (discountValidity < requiredValidity) {
    message = ubian.translate("JS.Error.TimeTicket.DiscountExpires", {
      "%date%": moment(discountValidity * 1000).format(ubian.config.dateFormat),
    });
  }

  ubian.utils.alert(message, title);
};

/**
 * request ifc time ticket renewal
 * @param {type} snr
 * @param {type} companyID
 * @param {type} ctl
 * @param {type} validTo
 * @param {type} zones
 * @returns {undefined}
 */
ubian.timeTicket.renewIFC = function (snr, companyID, ctl, validTo, zones) {
  window.location =
    ubian.routes["time_ticket_renew_ifc"] +
    "?snr=" +
    snr +
    "&companyID=" +
    companyID +
    "&ctl=" +
    ctl +
    "&validTo=" +
    validTo +
    "&zones=" +
    zones;
};

ubian.timeTicket.initInlineTimeTicketPicker = function () {
  $('.js-show-inline-timeticket-picker').click(function () {
    $(this).hide();
    $(this).parent().find('.js-inline-timeticket-picker').show();
  });

  var $pickers = $(".js-inline-timeticket-picker");
  if (!$pickers.length) {
    return;
  }
  $pickers.find(".js-tariff-zone").change(function () {
    var $parent = $(this).parents(".js-inline-timeticket-picker");
    var $tariffSelect = $parent.find(".js-tariff-type");
    $tariffSelect.html('<option selected disabled>' + ubian.translate('TimeTicket.Tariff.Select') + '</option>');
    $tariffSelect.change();
    $tariffSelect.hide();
    $tariffSelect.before(ubian.utils.loader());
    $.get(ubian.routes["time_ticket_get_tariffs"], { 'tariffZone': $(this).val(), 'companyID': $parent.data('company-id'), 'MHD_IDS': $parent.data('mhd-ids') }, function (res) {
      var options = ['<option selected disabled>' + ubian.translate('TimeTicket.Tariff.Select') + '</option>'];
      ubian.utils.removeLoader();
      $tariffSelect.show();
      $(res.tariffs).each(function (idx, val) {
        options.push(
          '<option value="' +
          val.ctl +
          '" data-price="' + val.price.price.valueFloat.toFixed(2) + ' ' +
          val.price.price.currencySymbol + '" data-validity=' + val.validity + '" data-max-date="' + val.maxDate + '">' +
          val.tariffName +
          "</option>"
        );
      });
      $tariffSelect.html(options.join(''));
    });
  });
  $pickers.find('.js-tariff-type').change(function () {
    var $parent = $(this).parents(".js-inline-timeticket-picker");
    var $price = $parent.find('.js-tariff-price');
    var $btn = $parent.find('.js-select-tariff-inline');
    if ($(this).val()) {
      $price.show();
      $price.find('.value').text($(this).find('option:selected').data('price').replace('.', ','));
      $btn.prop('disabled', false);
    } else {
      $price.hide();
      $btn.prop('disabled', true);
    }
  });
  $pickers.find('.js-select-tariff-inline').click(function () {
    var $parent = $(this).parents(".js-inline-timeticket-picker");
    var tariffZone = $parent.find('.js-tariff-zone').val();
    var companyID = $parent.data('company-id');
    var snr = $parent.data('snr');
    var cardValidity = $parent.data('card-validity');
    var discountValidity = $parent.data('discount-validity');
    var validity = $parent.find('.js-tariff-type').find('option:selected').data('validity');
    var maxDate = $parent.find('.js-tariff-type').find('option:selected').data('max-date');

    var ctl = $parent.find('.js-tariff-type').val();
    ubian.timeTicket.showValiditySelectDialog(companyID, null, tariffZone, snr, ctl, validity, maxDate, cardValidity, discountValidity, null);
  });
};

ubian.timeTicket.initInlineNewTimeTicketCompanyPicker = function () {
  var $el = $('.js-new-timeticket-company-select');
  if (!$el.length) {
    return;
  }
  var $list = $el.find('ul');
  $('body').click(function (e) {
    if ($list.is(':visible')) {
      $list.hide();
    }
  });
  var $label = $el.find('.current-value');

  $el.click(function (e) {
    e.stopPropagation();
    $list.toggle();
  });
  var $btn = $('.js-timeticket-create-link');
  $list.find('li').click(function () {
    $label.html($(this).html());
    $btn.removeAttr('disabled');
    var mhdids = $(this).data('mhd-ids');
    var company = $(this).data('company-id');
    var url;
    if (mhdids) {
      url = ubian.routes['time_ticket_select_zones_main_mhd_ids'].replace('mid', mhdids).replace('cid', company);
    } else {
      url = ubian.routes['time_ticket_select_zones_main'].replace('mid', mhdids).replace('cid', company);
    }
    $btn.attr('href', url);
  });


}

$(function () {
  // $(".js-tariff-select").click(function () {
  //   if ($(this).data("ifc")) {
  //     ubian.timeTicket.renewIFC(
  //       $(this).data("snr"),
  //       $(this).data("company"),
  //       $(this).data("ctl"),
  //       $(this).data("valid-to"),
  //       $(this).data("zones")
  //     );
  //   } else {
  //     ubian.timeTicket.showValiditySelectDialog(
  //       $(this).data("company"),
  //       $(this).data("zones"),
  //       $(this).data("tariff-zone"),
  //       $(this).data("snr"),
  //       $(this).data("ctl"),
  //       $(this).data("validity"),
  //       $(this).data("max-date"),
  //       $(this).data("card-validity"),
  //       $(this).data("discount-validity"),
  //       $(this).data("from-date") ? $(this).data('from-date') : $(this).data('min-date')
  //     );
  //   }
  //   return false;
  // });
  $(".js-time-ticket-extend-disabled").click(function () {
    ubian.timeTicket.showExtendImpossibleDialog(
      $(this).data("buy-allowed"),
      $(this).data("required-validity"),
      $(this).data("card-validity"),
      $(this).data("discount-validity"),
      $(this).data("pcl-sale"),
      $(this).data("pcl-available")
    );
    return false;
  });
  $(".js-photo-confirmation-link").click(function (e) {
    // e.preventDefault();
    // var url = $(this).attr('href');
    // ubian.utils.confirm(
    //   ubian.translate("JS.Purse.PhotoConfirmation.Text"),
    //   "",
    //   ubian.translate("Buttom.TimeTicket.Confirm"),
    //   url
    // );
  })
  ubian.timeTicket.initInlineTimeTicketPicker();
  ubian.timeTicket.initInlineNewTimeTicketCompanyPicker();
});
